import { InfoCircleOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { ErrorColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconInfoCircleError: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <InfoCircleOutlined
            {...props}
            type="info-circle"
            style={{ ...props.style, color: ErrorColor }}
        />
    );
};
